export const shopFloor = {
  descReady: "Your work queue and the operations ready to run.",
  descLive: "Live view of work across the shop.",
  allWorkCenters: "All work centres",
  workQueue: "Work queue",
  emptyQueueTitle: "No operations in this queue",
  emptyQueueDesc: "Released operations will appear here as work progresses.",
  selectOperation: "Select an operation",
  selectOperationDesc:
    "Choose an operation from the queue to see instructions, time, and reporting actions.",
  noWorkCenter: "No work centre",
  dueAt: "due {date}",
  internal: "Internal",
  qty: "Qty",
  start: "Start",
  pause: "Pause",
  resume: "Resume",
  complete: "Complete",
  unblock: "Unblock",
  block: "Block",
  operationStarted: "Operation started",
  operationPaused: "Operation paused",
  operationResumed: "Operation resumed",
  operationUnblocked: "Operation unblocked",
  operationBlocked: "Operation blocked",
  operationCompleted: "Operation completed",
  photoAttached: "Photo attached",
  startedAt: "Started {time}",
  totalTime: "Total time {minutes} minutes",
  blockQuestion: "What's blocking the work?",
  blockOperation: "Block operation",
  attachPhoto: "Attach photo",
  upload: "Upload",
  operations: "Operations",
  documents: "Drawings & documents",
  download: "Download",
  issues: "Issues",
  reported: "Reported",
  goodQuantity: "Good quantity",
  scrapQty: "Scrap qty",
  scrapReason: "Scrap reason",
  reworkQty: "Rework qty",
  reworkReason: "Rework reason",
  addScrap: "Add scrap",
  addRework: "Add rework",
  note: "Note",
  completeOperation: "Complete operation",
};
